import MessageIcon from '@material-ui/icons/ViewList';

import MessageList from './ParkingVehicleList';
import ParkingVehicleCreate from './ParkingVehicleCreate';
import ParkingVehicleEdit from "./ParkingVehicleEdit";

export default {
    list: MessageList,
    icon: MessageIcon,
    create: ParkingVehicleCreate,
    edit: ParkingVehicleEdit,
};
